export const SET_ALL_ENUMS = 'SET_ALL_ENUMS';

export const setAllEnums = (LevelUrgencyStatus) => ({
  type: SET_ALL_ENUMS,
  payload: LevelUrgencyStatus,
});